module.exports = __webpack_public_path__ + "assets/img/house-5.fcd173ab.jpeg";